import { render } from "./WhoWheAre.vue?vue&type=template&id=efc53dd4"
import script from "./WhoWheAre.vue?vue&type=script&lang=ts"
export * from "./WhoWheAre.vue?vue&type=script&lang=ts"
script.render = render

export default script